module.exports = __webpack_public_path__ + "img/Macao.f866a26c.svg";